var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('EMChart',{ref:"emChart",attrs:{"options":_vm.options}}),_c('EMOverlay',{attrs:{"showOverlay":!_vm.chartHasData,"text":_vm.$t('no_values'),"icon":"mdi-database-off-outline"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }